import "@lottiefiles/lottie-player";

// Polyfill
import 'intersection-observer';


let options = {
  root: null,
  rootMargin: "0px",
  threshold: 0.5,
};

const callback = (entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('in-view');
      if (entry.target.isReady) {  // Check if the player is ready
        entry.target.play();  // Play the animation
      } else {
        entry.target.addEventListener('ready', () => {
          entry.target.play();
        }, {once: true});  // Ensure event listener is removed after firing once
      }
    } else {
      if (entry.target.classList.contains('in-view')) {
        observer.unobserve(entry.target);
      }
    }
  });
};

const observer = new IntersectionObserver(callback, options);

document.querySelectorAll(".js-lottie-file").forEach(node => {
  const player = node.querySelector("lottie-player");
  if (player) {
    // Assume 'load' or 'ready' event is emitted when player is fully ready
    player.addEventListener('load', () => {
      player.isReady = true;  // Mark player as ready
      observer.observe(player);
    }, {once: true});
  }
});

window.onload = function() {
  // Only show the animation when the page is fully loaded
  document.querySelector(".js-lottie-file").classList.add('loaded');
};